import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ohadaCountries = [
  { name: "Bénin", flag: "https://flagcdn.com/w320/bj.png" },
  { name: "Burkina Faso", flag: "https://flagcdn.com/w320/bf.png" },
  { name: "Cameroun", flag: "https://flagcdn.com/w320/cm.png" },
  { name: "République Centrafricaine", flag: "https://flagcdn.com/w320/cf.png" },
  { name: "Comores", flag: "https://flagcdn.com/w320/km.png" },
  { name: "Congo", flag: "https://flagcdn.com/w320/cg.png" },
  { name: "Côte d'Ivoire", flag: "https://flagcdn.com/w320/ci.png" },
  { name: "Gabon", flag: "https://flagcdn.com/w320/ga.png" },
  { name: "Guinée", flag: "https://flagcdn.com/w320/gn.png" },
  { name: "Guinée-Bissau", flag: "https://flagcdn.com/w320/gw.png" },
  { name: "Guinée Équatoriale", flag: "https://flagcdn.com/w320/gq.png" },
  { name: "Mali", flag: "https://flagcdn.com/w320/ml.png" },
  { name: "Niger", flag: "https://flagcdn.com/w320/ne.png" },
  { name: "Sénégal", flag: "https://flagcdn.com/w320/sn.png" },
  { name: "Tchad", flag: "https://flagcdn.com/w320/td.png" },
  { name: "Togo", flag: "https://flagcdn.com/w320/tg.png" },
];

const countriesLoop = [...ohadaCountries, ...ohadaCountries];

const OHADACountries = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 5000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <Section>
      <Title>Pays membres de l’<span>OHADA</span></Title>
      
      {/* Masque en forme d'Afrique */}
      <AfricaMask>
        <AfricaSVG />
      </AfricaMask>

      {/* Défilement des drapeaux en dehors du masque */}
      <SliderContainer>
        <Slider {...settings}>
          {countriesLoop.map((country, index) => (
            <Slide key={index}>
              <Flag src={country.flag} alt={country.name} />
              <CountryName>{country.name}</CountryName>
            </Slide>
          ))}
        </Slider>
      </SliderContainer>
    </Section>
  );
};

export default OHADACountries;

// STYLES 🎨
const Section = styled.section`
  padding: 60px 10%;
  text-align: center;
  background: #ffffff;
  position: relative;
`;

const Title = styled.h2`
  font-size: 2.2rem;
  font-weight: bold;
  color: #228B22;
  margin-bottom: 30px;
  span {
    color: #E60000;
  }

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

/* Positionnement de l'Afrique sur la droite */
const AfricaMask = styled.div`
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  width: 150px;
  height: 150px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 100px;
  }
`;

/* SVG en forme d'Afrique */
const AfricaSVG = () => (
  <svg
    width="120"
    height="150"
    viewBox="0 0 200 200"
    fill="#228B22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M85,5 C125,20 180,50 185,100 C190,140 160,180 130,190 C100,200 70,185 45,160 C20,135 10,105 10,75 C10,40 35,20 85,5 Z" fill="currentColor" />
  </svg>
);

const SliderContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  overflow: hidden;
  padding-left: 150px; /* Décalage pour bien voir l'effet du masque */

  @media (max-width: 768px) {
    padding-left: 0;

  }
`;

const Slide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
`;

const Flag = styled.img`
  width: 100px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
  }
`;

const CountryName = styled.p`
  margin-top: 10px;
  font-size: 1rem;
  font-weight: bold;
  color: #333;
`;
